/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const mastercard = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="M6.658 7.5A4.229 4.229 0 0 0 6.676 9M8 5.07a4.2 4.2 0 1 1 0 6.261m0 0A4.19 4.19 0 0 0 9.4 8.2 4.19 4.19 0 0 0 8 5.07a4.2 4.2 0 1 0 0 6.261Z"
    />
  </svg>
)
export default mastercard
